import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// FIX: Patch removeChild/insertBefore to prevent crash from Chrome mobile
// features (auto-translate, password suggestions, accessibility)
// that modify the DOM outside of React's control.
// This is a well-known React issue: https://github.com/facebook/react/issues/17256
if (typeof Node !== 'undefined') {
  const origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        return child.parentNode.removeChild(child);
      }
      return child;
    }
    return origRemoveChild.apply(this, arguments);
  };

  const origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function(newNode, refNode) {
    if (refNode && refNode.parentNode !== this) {
      return newNode;
    }
    return origInsertBefore.apply(this, arguments);
  };
}

// Handle chunk loading failures (old cached JS from previous deploys)
window.addEventListener('error', (event) => {
  if (event.message && (
    event.message.includes('Loading chunk') ||
    event.message.includes('Loading CSS chunk') ||
    event.message.includes('ChunkLoadError')
  )) {
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
